module.exports = __webpack_public_path__ + "media/images/icons/package-cbdc473fe97cd46972321bd9f3c8e496.svg";